export const DESKTOP = 'DESKTOP';
export const MOBILE = 'MOBILE';
export const MOBILE_LANDSCAPE = 'MOBILE_LANDSCAPE';
export const TABLET = 'TABLET';
export const Devices = {
  DESKTOP,
  MOBILE,
  MOBILE_LANDSCAPE,
  TABLET
};